import React from 'react';

import axios from '../util/Api'

import {  Table, Tag ,Modal, message , Auxiliary, Row, Col, Form, Input, Button, Select, Space, Slider, Checkbox, InputNumber, Switch, Tooltip, Progress, Alert} from 'antd';

import {
  BrowserRouter as Router,
  Route,
  Link
} from "react-router-dom";

import {getTypeArticleOption, getMachineId} from "../util/Toolbox";

import './css/containersFormulaire.css';

import iconeHeader from './assets/analyseFormulaire/picto_analyse.svg';
import goutte_eau_header from './assets/analyseFormulaire/goutte_eau_header.svg';



import {
  EditOutlined
} from '@ant-design/icons';

import ElectronWaterLinkService from '../services/ElectronWaterLinkService';
import { resoudreDisque, echantillonsCompatibles, echantillonParDefaut, lireDisqueDefaut } from '../services/spintouchConfig';
import { champsFormulaire } from '../services/spintouchResults';

class AvaForms extends React.Component {

  state = {

    IsFiltreASable : false,
    IsFiltreACartouche : false,
    IsFiltreADiatomee : false,
    IsPocheFiltration : false,

    TempsFiltration : undefined,
    TauxSelAppareil : undefined,
    TemperatureEau : undefined,
    VolumeBassin : '',

    IsTypeDesinfection_ChloreGalet : false,
    IsTypeDesinfection_Brome : false,
    IsTypeDesinfection_ChloreLiquide : false,
    IsTypeDesinfection_Eletrolyseur: false,

    IsTypeEau_MoyenneDure : false,
    IsTypeEau_Dure : false,
    IsTypeEau_TresDur : false,
    IsTypeEau_NeSaisPas : false,

    IsAspect_EauClaire : false,
    IsAspect_EauTrouble : false,
    IsAspect_EauVerte : false,

    loadingButton: false,

    IsAnalysePro : false,
    IsEnCoursDeSaison : false,
    ReferenceAnalyse : '',

    ValeurPH : 7.6,
    ValeurChloreLibre : -1,

    guid_compte: 'fsdfsdsdfsdfsd',

    isElectron: false,
    valeurInputMode: 'manual',
    spintouchStatus: null,
    spintouchLoading: false,
    spintouchError: null,
    spintouchResults: null,
    spintouchOptions: null,
    spintouchDisque: null,
    spintouchEchantillons: [],
    spintouchEchantillon: null,
    spintouchOptionsErreur: null,
    spintouchProgress: 0

  }


  async componentDidMount() {

    // Récupèration des paramètres dans l'URL si il y en a
    const search  = window.location.search;
    const params  = new URLSearchParams(search);
    const volume  = params.get('volume');

    let guid_compte = getMachineId();

    console.log('guid_compte', guid_compte);

    this.state.guid_compte = guid_compte;




    const isElectron = ElectronWaterLinkService.isElectronApp();
    this.setState({ isElectron });

    if(volume != null){
      this.setState({VolumeBassin: volume});
    }

  }

  componentWillUnmount() {
    if (this.spintouchIntervalId) {
      clearInterval(this.spintouchIntervalId);
      this.spintouchIntervalId = null;
    }
  }

  // Péride de l'analyse
  onChangedebutSaison = (e: CheckboxChangeEvent) => {
  //  this.resetTypeDesinfection();

    console.log(e.target.checked);
    this.setState({IsEnCoursDeSaison:e.target.checked})
  };


  onChangedebutSaison2 = (e: CheckboxChangeEvent) => {
  //  this.resetTypeDesinfection();

    console.log(e.target.checked);
    this.setState({IsEnCoursDeSaison:!e.target.checked})
  };



  // Type Filtration
  onChangeTypeFiltration_Sable = (e: CheckboxChangeEvent) => {
    this.resetTypeFiltration();
    this.setState({IsFiltreASable:e.target.checked})
  };

  onChangeTypeFiltration_Cartouche = (e: CheckboxChangeEvent) => {
    this.resetTypeFiltration();
    this.setState({IsFiltreACartouche:e.target.checked})
  };

  onChangeTypeFiltration_Diatomee = (e: CheckboxChangeEvent) => {
    this.resetTypeFiltration();
    this.setState({IsFiltreADiatomee:e.target.checked})
  };

  onChangeTypeFiltration_Filtration = (e: CheckboxChangeEvent) => {
    this.resetTypeFiltration();
    this.setState({IsPocheFiltration:e.target.checked})
  };



  // Type désinfection
  onChangeTypeDesinfection_ChloreGalet = (e: CheckboxChangeEvent) => {
    this.resetTypeDesinfection();
    this.setState({IsTypeDesinfection_ChloreGalet:e.target.checked})
  };

  onChangeTypeDesinfection_Brome = (e: CheckboxChangeEvent) => {
    this.resetTypeDesinfection();
    this.setState({IsTypeDesinfection_Brome:e.target.checked})
  };

  onChangeTypeDesinfection_ChloreLiquide = (e: CheckboxChangeEvent) => {
    this.resetTypeDesinfection();
    this.setState({IsTypeDesinfection_ChloreLiquide:e.target.checked})
  };

  onChangeTypeDesinfection_Electrolyseur = (e: CheckboxChangeEvent) => {
    this.resetTypeDesinfection();
    this.setState({IsTypeDesinfection_Eletrolyseur:e.target.checked})
  };


  // Type eau
  onChangeTypeEau_MoyenneDure = (e: CheckboxChangeEvent) => {
    this.resetTypeEau();
    this.setState({IsTypeEau_MoyenneDure:e.target.checked, ValeurTH : parseFloat(149) })
  };

  onChangeTypeEau_Dure = (e: CheckboxChangeEvent) => {
    this.resetTypeEau();
    this.setState({IsTypeEau_Dure:e.target.checked, ValeurTH : parseFloat(249) })
  };

  onChangeTypeEau_TresDure = (e: CheckboxChangeEvent) => {
    this.resetTypeEau();
    this.setState({IsTypeEau_TresDur:e.target.checked, ValeurTH : parseFloat(399) })
  };

  onChangeTypeEau_NeSaisPas = (e: CheckboxChangeEvent) => {
    this.resetTypeEau();
    this.setState({IsTypeEau_NeSaisPas:e.target.checked})
  };


  // Aspect de l'Eau
  onChangeAspectEau_Transparent = (e: CheckboxChangeEvent) => {
    this.resetTypeAspectEau();
    this.setState({IsAspect_EauClaire:e.target.checked})
  };

  onChangeAspectEau_Trouble= (e: CheckboxChangeEvent) => {
    this.resetTypeAspectEau();
    this.setState({IsAspect_EauTrouble:e.target.checked})
  };

  onChangeAspectEau_Verte= (e: CheckboxChangeEvent) => {
    this.resetTypeAspectEau();
    this.setState({IsAspect_EauVerte:e.target.checked})
  };


  handleChangeValue(dataType, value) {

    this.setState({[dataType]: value});
}




  /**
   * Reporte les mesures du photometre dans les champs du formulaire.
   * La lecture du resultat vit dans services/spintouchResults.
   */
  appliquerMesuresSpintouch(result) {
    this.setState(champsFormulaire(result));
  }

  utiliserResultatsSpintouch = () => {
    const { spintouchResults } = this.state;
    if (!spintouchResults) {
      message.warning('Aucun résultat à utiliser');
      return;
    }
    this.appliquerMesuresSpintouch(spintouchResults);
    this.setState({ valeurInputMode: 'manual' });
    message.success('Résultats appliqués au formulaire');
  }

  /**
   * Interroge l'appareil pour connaitre sa gamme de disques et d'echantillons,
   * puis preselectionne le type de mesure d'apres le type de desinfection
   * deja coche dans le formulaire.
   */
  async chargerOptionsSpintouch() {
    this.setState({ spintouchOptionsErreur: null });
    try {
      const options = await ElectronWaterLinkService.getOptions();
      const disque = resoudreDisque(options && options.ReagentTypes);
      const echantillons = echantillonsCompatibles(options && options.SampleTypes, disque);

      this.setState({
        spintouchOptions: options,
        spintouchDisque: disque,
        spintouchEchantillons: echantillons,
        spintouchEchantillon: echantillonParDefaut(echantillons, this.state)
      });
    } catch (error) {
      this.setState({
        spintouchOptions: null,
        spintouchDisque: null,
        spintouchEchantillons: [],
        spintouchEchantillon: null,
        spintouchOptionsErreur: (error && error.message) ? error.message : 'Appareil injoignable'
      });
    }
  }

  passerEnModeSpintouch = () => {
    this.setState({ valeurInputMode: 'spintouch' });
    this.chargerOptionsSpintouch();
  }

  choisirEchantillonSpintouch = (value) => {
    this.setState({
      spintouchEchantillon: this.state.spintouchEchantillons.find(e => e.value === value) || null
    });
  }

  async lancerAnalyseSpintouch() {
    if (!this.state.isElectron) {
      message.error('Disponible uniquement sous Electron');
      return;
    }
    this.setState({ spintouchLoading: true, spintouchError: null, spintouchStatus: 'Initialisation...', spintouchProgress: 0 });
    if (this.spintouchIntervalId) {
      clearInterval(this.spintouchIntervalId);
      this.spintouchIntervalId = null;
    }
    this.spintouchIntervalId = setInterval(() => {
      this.setState((prev) => {
        const next = Math.min(120, (prev.spintouchProgress || 0) + 1);
        return { spintouchProgress: next };
      });
    }, 1000);
    try {
      // Le service se charge de savoir s'il parle a Electron, au service local
      // ou a la simulation de developpement, et leve l'erreur qui convient.
      await ElectronWaterLinkService.checkService();

      this.setState({ spintouchStatus: 'Service disponible, vérification de l\'appareil...' });

      try {
        const status = await ElectronWaterLinkService.getStatus();
        this.setState({ spintouchStatus: `Statut appareil: ${ElectronWaterLinkService.getStatusText(status && status.Status)}` });
      } catch (e) {
        console.warn('Impossible de récupérer le statut:', e);
      }

      // Le disque et l'echantillon sont determines avant le lancement : sans
      // eux on ne teste pas, plutot que de bruler un disque sur un mauvais
      // reglage.
      const disque = this.state.spintouchDisque;
      const echantillon = this.state.spintouchEchantillon;

      if (!disque) {
        throw new Error(`Le disque configuré (${lireDisqueDefaut().name}) n'est pas proposé par l'appareil. Vérifiez la configuration dans la page SpinTouch.`);
      }
      if (!echantillon) {
        throw new Error('Sélectionnez le type de mesure avant de lancer l\'analyse.');
      }
      this.setState({ spintouchStatus: `Analyse en cours (${disque.Name} — ${echantillon.libelle})...` });
      const result = await ElectronWaterLinkService.runWaterTest(disque.Value, echantillon.value);
      this.setState({ spintouchResults: result });

      this.appliquerMesuresSpintouch(result);

      message.success('Mesures Spintouch importées');
    } catch (err) {
      const msg = (err && err.message) ? err.message : 'Erreur Spintouch';
      this.setState({ spintouchError: msg });
      message.error(msg);
    } finally {
      if (this.spintouchIntervalId) {
        clearInterval(this.spintouchIntervalId);
        this.spintouchIntervalId = null;
      }
      this.setState({ spintouchLoading: false, spintouchProgress: 120 });
    }
  }

  // Reset fonction
  resetTypeFiltration(){
    this.setState({IsFiltreASable : false, IsFiltreACartouche : false, IsFiltreADiatomee: false, IsPocheFiltration : false, loadingButton : false  })
  }

  resetTypeDesinfection(){
    this.setState({IsTypeDesinfection_ChloreGalet : false, IsTypeDesinfection_ChloreLiquide : false, IsTypeDesinfection_Brome: false, IsTypeDesinfection_Eletrolyseur : false,  loadingButton : false    })
  }

  resetTypeEau(){
    this.setState({IsTypeEau_MoyenneDure : false, IsTypeEau_Dure : false, IsTypeEau_TresDur: false, IsTypeEau_NeSaisPas : false ,  loadingButton : false   })
  }

  resetTypeAspectEau(){
    this.setState({IsAspect_EauClaire : false, IsAspect_EauTrouble : false, IsAspect_EauVerte: false,  loadingButton : false   })
  }



  // Bouton formulaire
  validationFormulaire = () => {


    if(!this.state.VolumeBassin > 0){
      message.warning("Entrer le volume de votre bassin");
      return;
    }

    if(this.state.IsFiltreASable == false && this.state.IsFiltreACartouche == false && this.state.IsFiltreADiatomee == false && this.state.IsPocheFiltration == false ){
      message.warning("Sélectionner un type de filtration");
      return;
    }

    if(!this.state.TempsFiltration > 0){
      message.warning("Entrer le temps de filtration journalier de votre bassin en heure");
      return;
    }


    if(this.state.IsTypeDesinfection_ChloreGalet == false && this.state.IsTypeDesinfection_Brome == false && this.state.IsTypeDesinfection_ChloreLiquide == false && this.state.IsTypeDesinfection_Eletrolyseur == false ){
      message.warning("Sélectionner un type de désinfection");
      return;
    }
    /*
    if(this.state.IsTypeDesinfection_Eletrolyseur == true && !this.state.TauxSelAppareil > 0  ){
      message.warning("Entrer le taux de sel recommandé par l'appareil (en g/l)");
      return;
    }
    */
    if(this.state.IsTypeEau_MoyenneDure == false && this.state.IsTypeEau_Dure == false && this.state.IsTypeEau_TresDur == false && this.state.IsTypeEau_NeSaisPas == false ){
      message.warning("Compléter l'onglet eau calcaire");
      return;
    }

    if(this.state.IsAspect_EauClaire == false && this.state.IsAspect_EauTrouble == false && this.state.IsAspect_EauVerte == false  ){
      message.warning("Sélectionner l'aspect de l'eau");
      return;
    }

    if(!this.state.TemperatureEau > 0){
      message.warning("Entrer la température de l'eau de votre bassin");
      return;
    }

    if(this.state.IsTypeDesinfection_ChloreGalet == true){

        console.log(this.state.ValeurChloreLibre);

        if(this.state.ValeurChloreLibre >= 0) {

        }else{
          message.warning("Entrer le niveau de chlore de votre bassin");
          return;
        }
    }



    this.setState({ loadingButton: true });

    // analyse
    if(this.state.ValeurChloreLibre <= 0){
      this.state.ValeurChloreLibre = null;
    }



    const messageIndicator = message.loading('Analyse en cours...', 0);

    let formulaire = {
      TemperatureEau : this.state.TemperatureEau,
      TempsFiltration : this.state.TempsFiltration
    }

    console.log(this.state)


      // APPEL API
    axios.post('/analyse/createAnalyse', {analyse : this.state},
    ).then(({data}) => {
      console.log(data);
      console.log(data.result)
      console.log(data.GUIDAnalyse)

      window.location.href= '/analyse?analyse='+ data.GUIDAnalyse;
      this.setState({ loadingButton: false });

      setTimeout(messageIndicator, 10);
    }).catch(function (error) {
      setTimeout(messageIndicator, 10);

      console.log("Error****:", error.message);
      message.error("Erreur lors de l'analyse");
    });



  };


  onChangeSlider = (dataType, value) => {

    this.setState({[dataType]: parseFloat(value)});
  }


  render() {

      return (

        <div className = "wrapper_analyse">

          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>

          <div className = "wrapper_analyse_header">

            <img loading="lazy"  src={iconeHeader} />

            <p className = "wrapper_analyse_header_Title">Analyse</p>

            <div className = "header_image_goutte">
              <img loading="lazy" src={goutte_eau_header} />
            </div>

          </div>

            <div>

              <div className = "containersFormulaire">

                <Row style = {{marginTop:10, marginBottom:-20}}>
                  <Col sm={12} xs={12}>
                  { this.state.IsAnalysePro == true &&
                    <div className = "referenceAnalyse">
                     <Input placeholder='Réf, nom, société ...' value={this.state.ReferenceAnalyse} onChange={(event) => this.setState({ReferenceAnalyse: event.target.value})}/>
                    </div>
                  }

                  </Col>
                  <Col sm={12} xs={12}>
                    <div className = "proAnalyse">
                    <span>Je suis un professionnel</span>
                    <Switch style = {{marginLeft : 5}} checked={Boolean(this.state.IsAnalysePro)} onChange={this.handleChangeValue.bind(this, 'IsAnalysePro')} />
                    </div>
                  </Col>
                </Row>

                <div>

                  <h4>Volume du bassin</h4>


                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={12} xs={12}>
                      <p>Je connais le volume</p>
                    </Col>
                    <Col sm={10} xs={10} className = "fondFormulaireFont" >
                      <InputNumber decimalSeparator="," min={1} max={10000} style= {{marginTop: 10, width : '100%'}} value={this.state.VolumeBassin} onChange={(event) => this.setState({VolumeBassin: event})}/>
                    </Col>
                    <Col sm={2} xs={2}>
                      <p>m³</p>
                    </Col>
                  </Row>

                  <p style = {{marginTop:20}}>{"Je ne connais pas le volume"}
                   <Link to="/simulateur"><Button style={{marginLeft: 16, backgroundColor: '#1B9BD7', color: 'white', fontWeight : 700}}>Calculer</Button></Link>
                  </p>
                  </div>
                </div>


                <div>
                  <h4>Période de l'analyse</h4>
                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {Boolean(!this.state.IsEnCoursDeSaison) }  onChange={this.onChangedebutSaison2}>en début de saison</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {Boolean(this.state.IsEnCoursDeSaison)} onChange={this.onChangedebutSaison}>en cours de saison</Checkbox>
                    </Col>
                  </Row>
                </div>
               </div>


                <div>
                  <h4>Type de filtration</h4>
                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsFiltreASable}  onChange={this.onChangeTypeFiltration_Sable}>filtre à sable / verre</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsFiltreADiatomee} onChange={this.onChangeTypeFiltration_Diatomee}>filtre à diatomée</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsFiltreACartouche} onChange={this.onChangeTypeFiltration_Cartouche}>filtre à cartouche</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsPocheFiltration} onChange={this.onChangeTypeFiltration_Filtration}>poche de filtration</Checkbox>
                    </Col>
                  </Row>
                  <p style = {{marginBottom:0}}>Temps de filtration journalier (en heure)</p>
                  <InputNumber value = {this.state.TempsFiltration}  placeholder = "Durée en heure" style={{width: '100%', marginTop : 0, color: 'blue'}} min={1} max={24}  onChange={(event) => this.setState({TempsFiltration: event})} />
                  </div>
                </div>

                <div>
                  <h4>Type de désinfection</h4>
                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeDesinfection_ChloreGalet}  onChange={this.onChangeTypeDesinfection_ChloreGalet}>chlore galet</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeDesinfection_Brome} onChange={this.onChangeTypeDesinfection_Brome}>brome</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeDesinfection_ChloreLiquide} onChange={this.onChangeTypeDesinfection_ChloreLiquide}>chlore liquide</Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeDesinfection_Eletrolyseur} onChange={this.onChangeTypeDesinfection_Electrolyseur}>électrolyseur au sel</Checkbox>
                    </Col>
                  </Row>
                  {this.state.IsTypeDesinfection_Eletrolyseur == true &&
                    <InputNumber value = {this.state.TauxSelAppareil}  placeholder = "Taux de sel recommandé par l'appareil (en g/L)" style={{width: '100%', marginTop : 0, color: 'blue'}} min={1} onChange={(event) => this.setState({TauxSelAppareil: event})} />
                  }
                </div>

                </div>

                <div>
                  <h4>Eau calcaire</h4>
                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeEau_MoyenneDure}  onChange={this.onChangeTypeEau_MoyenneDure}>eau moyennement dure <span className = "checkBoxFormSpan">TH inférieur à 200mg/L (20°F)</span></Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeEau_Dure} onChange={this.onChangeTypeEau_Dure}>eau dure <span className = "checkBoxFormSpan">TH supérieur à 200mg/L (20°F)</span></Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeEau_TresDur} onChange={this.onChangeTypeEau_TresDure}>eau très dure <span className = "checkBoxFormSpan">TH supérieur à 400mg/L (40°F)</span></Checkbox>
                    </Col>
                    <Col sm={12} xs={12}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsTypeEau_NeSaisPas} onChange={this.onChangeTypeEau_NeSaisPas}>je ne sais pas</Checkbox>
                    </Col>
                  </Row>
                </div>

                </div>

                <div>

                  <h4>Aspect de l'eau</h4>

                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={24} xs={24}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsAspect_EauClaire}  onChange={this.onChangeAspectEau_Transparent}>eau claire transparente</Checkbox>
                    </Col>
                    <Col sm={24} xs={24}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsAspect_EauTrouble} onChange={this.onChangeAspectEau_Trouble}>eau trouble</Checkbox>
                    </Col>
                    <Col sm={24} xs={24}>
                      <Checkbox className = "checkBoxForm" checked = {this.state.IsAspect_EauVerte} onChange={this.onChangeAspectEau_Verte}>eau verte</Checkbox>
                    </Col>

                  </Row>
                </div>
                </div>

                <div>
                  <h4>Température de l'eau</h4>

                  <div className="fondFormulaire">
                  <Row gutter = {8}>
                    <Col sm={24} xs={24}>
                        <InputNumber value = {this.state.TemperatureEau}  placeholder = "Température en C°" style={{width: '100%', marginTop : 0, color: 'blue'}} min={1} onChange={(event) => this.setState({TemperatureEau: event})} />
                    </Col>
                  </Row>

                  </div>

                </div>

                <div>

                  <h4>Valeurs mesurées</h4>

                  { (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center', justifyContent: 'center', margin: '8px 0 12px 0' }}>
                      <div
                        onClick={() => this.setState({ valeurInputMode: 'manual' })}
                        style={{ cursor: 'pointer', textAlign: 'center', padding: 12, borderRadius: 8, backgroundColor: this.state.valeurInputMode === 'manual' ? '#90CAF9' : '#E3F2FD', border: this.state.valeurInputMode === 'manual' ? 'none' : '1px solid #ddd', minWidth: 140, display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}
                        title="Saisie manuelle des valeurs"
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="#005397"/>
                        </svg>
                        <Tooltip title="Saisie manuelle des valeurs">
                             <div style={{ fontWeight: 600, color: '#005397' }}>Saisie manuelle</div>
                        </Tooltip>
                      </div>
                      {this.state.isElectron && (
                      <Tooltip title="Connexion au SpinTouch pour importer les mesures">
                      <div
                        onClick={this.passerEnModeSpintouch}
                        style={{
                          cursor: 'pointer',
                          textAlign: 'center',
                          padding: 12,
                          borderRadius: 8,
                          backgroundColor: this.state.valeurInputMode === 'spintouch' ? '#90CAF9' : '#E3F2FD',
                          border: this.state.valeurInputMode === 'spintouch' ? 'none' : '1px solid #ddd',
                          minWidth: 140,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                          justifyContent: 'center'
                        }}
                        title="Connexion au SpinTouch"
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="7" y="4" width="10" height="5" rx="1" fill="#005397"/>
                          <rect x="8" y="5" width="2" height="1" fill="#E3F2FD"/>
                          <rect x="10.5" y="5" width="2" height="1" fill="#E3F2FD"/>
                          <path d="M6 9h12v9c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V9z" fill="#005397"/>
                          <path d="M8 11h8v5H8v-5z" fill="#E3F2FD"/>
                          <path d="M11.5 12.5l-1.5 3h3l-1.5-3z" fill="#FFFFFF" stroke="#005397" strokeWidth="0.5"/>
                        </svg>
                        <div style={{ fontWeight: 600, color: '#005397' }}>Connexion au SpinTouch</div>
                      </div>
                      </Tooltip>
                      )}
                    </div>
                  )}

                  { this.state.isElectron === true && this.state.valeurInputMode === 'spintouch' && (
                    <div className="fondFormulaire" style={{ marginBottom: 12, marginTop: 12 }}>
                      <Row gutter={8}>
                        <Col sm={24} xs={24}>
                          <p style={{ marginBottom: 8 }}>Lancer une analyse Spintouch pour importer automatiquement les mesures.</p>

                          { this.state.spintouchError && <p style={{ color: 'red', marginBottom: 8 }}>{this.state.spintouchError}</p> }

                          { this.state.spintouchOptionsErreur && (
                            <Alert
                              style={{ marginBottom: 8 }}
                              type="warning"
                              showIcon
                              message="Appareil injoignable"
                              description={`Impossible de lire les options du photomètre : ${this.state.spintouchOptionsErreur}`}
                            />
                          )}

                          { this.state.spintouchOptions && !this.state.spintouchDisque && (
                            <Alert
                              style={{ marginBottom: 8 }}
                              type="warning"
                              showIcon
                              message="Disque introuvable"
                              description={`L'appareil ne propose pas « ${lireDisqueDefaut().name} ». Choisissez le disque à utiliser dans la page SpinTouch.`}
                            />
                          )}

                          { this.state.spintouchEchantillons.length > 0 && (
                            <div style={{ marginBottom: 12 }}>
                              <h5 style={{ marginBottom: 4 }}>Type de mesure</h5>
                              <Select
                                style={{ width: '100%', maxWidth: 260 }}
                                value={this.state.spintouchEchantillon ? this.state.spintouchEchantillon.value : undefined}
                                onChange={this.choisirEchantillonSpintouch}
                                options={this.state.spintouchEchantillons.map(e => ({ value: e.value, label: e.libelle }))}
                              />
                              { this.state.spintouchDisque && (
                                <p style={{ marginTop: 4, marginBottom: 0, color: '#888' }}>
                                  Disque : {this.state.spintouchDisque.Name}
                                </p>
                              )}
                            </div>
                          )}

                          <Button onClick={this.lancerAnalyseSpintouch.bind(this)} loading={this.state.spintouchLoading} disabled={!this.state.spintouchDisque || !this.state.spintouchEchantillon} style={{ backgroundColor: '#0093CF', color: 'white', fontWeight: 700 }}>
                            Lancer une analyse Spintouch
                          </Button>

                          { (this.state.spintouchLoading || (this.state.spintouchProgress > 0 && this.state.spintouchProgress < 120)) && (
                            <div style={{ marginTop: 12 }}>
                              <Progress percent={Math.round((this.state.spintouchProgress / 65) * 100)} status="active" />
                            </div>
                          )}

                          { this.state.spintouchResults && (
                            <div style={{ marginTop: 16 }}>
                              <h5 style={{ marginBottom: 8 }}>Résultats</h5>
                              { this.state.spintouchDisque && this.state.spintouchEchantillon && (
                                <p style={{ marginTop: -4, marginBottom: 8, color: '#888' }}>
                                  {this.state.spintouchDisque.Name} — {this.state.spintouchEchantillon.libelle}
                                </p>
                              )}
                              { Array.isArray(this.state.spintouchResults.Results) && this.state.spintouchResults.Results.length > 0 ? (
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 8 }}>
                                  <div style={{ fontWeight: 600 }}>Paramètre</div>
                                  <div style={{ fontWeight: 600 }}>Valeur</div>
                                  <div style={{ fontWeight: 600 }}>Unités</div>
                                  <div style={{ fontWeight: 600 }}>Facteur</div>
                                  { this.state.spintouchResults.Results.map((r, idx) => (
                                    <React.Fragment key={idx}>
                                      <div>{r.Name || '-'}</div>
                                      <div>{typeof r.Value === 'number' ? r.Value.toFixed(r.Decimals || 0) : (r.Value ?? '-')}</div>
                                      <div>{r.Units || '-'}</div>
                                      <div>{r.FactorCode != null ? r.FactorCode : '-'}</div>
                                    </React.Fragment>
                                  ))}
                                </div>
                              ) : (
                                <div>
                                  <Alert
                                    message="Attention"
                                    description="Aucun résultat détecté par le SpinTouch. Vérifiez que l'appareil est correctement connecté."
                                    type="warning"
                                    showIcon
                                    closable
                                  />
                                </div>
                              )}
                              <div style={{ marginTop: 12 }}>
                                <Button type="primary" onClick={this.utiliserResultatsSpintouch}>
                                  Utiliser les résultats
                                </Button>
                              </div>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </div>
                  )}

                  { ((this.state.isElectron === true ? this.state.valeurInputMode === 'manual' : true)) && (
                  <div className = "valeur_mesuree">

                    <h5>Valeur du pH</h5>
                    <div className = "valeur_mesuree_item">
                      <Row>
                        <Col className = "valeur_mesuree_left" span={5} style = {{backgroundColor : "#FFCFA7", height:20}} ></Col>
                        <Col span={5} style = {{backgroundColor : "#FFB074",  height:20}}></Col>
                        <Col span={4} style = {{backgroundColor : "#FF9848", height:20}}></Col>
                        <Col span={5} style = {{backgroundColor : "#FF6C1D", height:20}}></Col>
                        <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#E96C1A", height:20}}></Col>
                      </Row>
                      <Slider onChange={this.onChangeSlider.bind(this, 'ValeurPH')} value = {this.state.ValeurPH} style = {{marginTop:-16}}  min={6} max={9} defaultValue={this.state.ValeurPH}  step={0.1} trackStyle={{ backgroundColor: 'blue' }} handleStyle={{ borderColor: 'blue' }}  />
                    </div>

                    {
                      (this.state.IsTypeDesinfection_ChloreGalet == true || this.state.IsTypeDesinfection_ChloreLiquide == true || this.state.IsTypeDesinfection_Eletrolyseur == true)   &&
                      (
                        <div>
                          <h5>Taux de chlore libre (mg/L)</h5>
                          <div className = "valeur_mesuree_item">
                            <Row>
                              <Col className = "valeur_mesuree_left" span={5} style = {{backgroundColor : "#DAAEDC", height:20}} ></Col>
                              <Col span={5} style = {{backgroundColor : "#D979DC", height:20}}></Col>
                              <Col span={4} style = {{backgroundColor : "#D051DB", height:20}}></Col>
                              <Col span={5} style = {{backgroundColor : "#BA32B6", height:20}}></Col>
                              <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#9C1F91", height:20}}></Col>
                            </Row>
                            <Slider onChange={this.onChangeSlider.bind(this, 'ValeurChloreLibre')} value = {this.state.ValeurChloreLibre} style = {{marginTop:-16}}  min={0} max={3} defaultValue={this.state.ValeurChloreLibre}  step={0.1}  />
                          </div>
                        </div>
                      )

                    }

                    {
                      this.state.IsTypeDesinfection_Brome == true &&
                      (
                        <div>
                          <h5>Teneur en brome (mg/L)</h5>
                          <div className = "valeur_mesuree_item">
                            <Row>
                              <Col className = "valeur_mesuree_left" span={5} style = {{backgroundColor : "#DAAEDC", height:20}} ></Col>
                              <Col span={5} style = {{backgroundColor : "#D979DC"}}></Col>
                              <Col span={4} style = {{backgroundColor : "#D051DB"}}></Col>
                              <Col span={5} style = {{backgroundColor : "#BA32B6"}}></Col>
                              <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#9C1F91"}}></Col>
                            </Row>
                            <Slider onChange={this.onChangeSlider.bind(this, 'ValeurBrome')} value = {this.state.ValeurBrome !== undefined ? this.state.ValeurBrome : 2} style = {{marginTop:-16}}  min={0} max={3} defaultValue={2}  step={0.1}  />
                          </div>
                        </div>

                      )
                    }

                    <h5>Alcanilité ou TAC (mg/L) <span style= {{fontWeight: 400}}> (facultatif) </span></h5>
                    <div className = "valeur_mesuree_item">
                      <Row>
                        <Col className = "valeur_mesuree_left"  span={5} style = {{backgroundColor : "#CFE9BA", height:20}} ></Col>
                        <Col span={5} style = {{backgroundColor : "#8BE1BA"}}></Col>
                        <Col span={4} style = {{backgroundColor : "#8BBBE3"}}></Col>
                        <Col span={5} style = {{backgroundColor : "#65A5E4"}}></Col>
                        <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#3981D5"}}></Col>
                      </Row>
                      <Slider onChange={this.onChangeSlider.bind(this, 'ValeurTAC')} value = {this.state.ValeurTAC !== undefined ? this.state.ValeurTAC : -1} style = {{marginTop:-16}}  min={-1} max={300} defaultValue={-1}  step={1}  />
                    </div>

                    <h5>Dureté totale ou TH (mg/L) <span style= {{fontWeight: 400}}> (facultatif) </span></h5>
                    <div className = "valeur_mesuree_item">
                      <Row>
                        <Col className = "valeur_mesuree_left"  span={5} style = {{backgroundColor : "#8AB52B", height:20}} ></Col>
                        <Col span={5} style = {{backgroundColor : "#B3C55E"}}></Col>
                        <Col span={4} style = {{backgroundColor : "#D3DE74"}}></Col>
                        <Col span={5} style = {{backgroundColor : "#E4E89F"}}></Col>
                        <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#EBEBC6"}}></Col>
                      </Row>
                      <Slider onChange={this.onChangeSlider.bind(this, 'ValeurTH')} value = {this.state.ValeurTH} style = {{marginTop:-16}}  min={-1} max={500} defaultValue={-1}  step={1}  />
                    </div>

                    <h5>Stabilisant (mg/L) <span style= {{fontWeight: 400}}> (facultatif) </span></h5>
                    <div className = "valeur_mesuree_item">
                      <Row>
                        <Col className = "valeur_mesuree_left"  span={5} style = {{backgroundColor : "#FFDED6", height:20}} ></Col>
                        <Col span={5} style = {{backgroundColor : "#F9C5B6"}}></Col>
                        <Col span={4} style = {{backgroundColor : "#FBACAD"}}></Col>
                        <Col span={5} style = {{backgroundColor : "#FD6F70"}}></Col>
                        <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#D65B5C"}}></Col>
                      </Row>
                      <Slider onChange={this.onChangeSlider.bind(this, 'ValeurStabilisant')} value = {this.state.ValeurStabilisant !== undefined ? this.state.ValeurStabilisant : -1} style = {{marginTop:-16}}  min={-1} max={150} defaultValue={-1}  step={1}  />
                    </div>

                    <h5>Phosphate en ppb <span style= {{fontWeight: 400}}> (facultatif) </span></h5>
                    <div className = "valeur_mesuree_item">
                      <Row>
                        <Col className = "valeur_mesuree_left"  span={5} style = {{backgroundColor : "#FFF8D4", height:20}} ></Col>
                        <Col span={5} style = {{backgroundColor : "#FAE5BB"}}></Col>
                        <Col span={4} style = {{backgroundColor : "#DFCABB"}}></Col>
                        <Col span={5} style = {{backgroundColor : "#CBB983"}}></Col>
                        <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#A49A79"}}></Col>
                      </Row>
                      <Slider onChange={this.onChangeSlider.bind(this, 'ValeurPhosphate')} value = {this.state.ValeurPhosphate !== undefined ? this.state.ValeurPhosphate : -1} style = {{marginTop:-16}}  min={-1} max={2500} defaultValue={-1}  step={1}  />
                    </div>

                  </div>
                  )}

                </div>

                <div className = "buttonForm">
                  <Button className = 'buttonFormStyle'  onClick={this.validationFormulaire} loading = {this.state.loadingButton} size={"large"} style={{fontWeight:600, paddingLeft:40, paddingRight:40, marginBottom: 100, backgroundColor: '#0093CF', color:'white'}}>Analyser</Button>
                </div>

              </div>

            </div>

        </div>





      )

    };
}

/*
{ this.state.IsTypeDesinfection_Eletrolyseur == true &&
  (
    <div>
      <h5>Taux de sel (g/L)</h5>
      <div className = "valeur_mesuree_item">
        <Row>
          <Col className = "valeur_mesuree_left"  span={5} style = {{backgroundColor : "#3D320D", height:20}} ></Col>
          <Col span={5} style = {{backgroundColor : "#544513"}}></Col>
          <Col span={4} style = {{backgroundColor : "#706233"}}></Col>
          <Col span={5} style = {{backgroundColor : "#A69870"}}></Col>
          <Col className = "valeur_mesuree_right" span={5} style = {{backgroundColor : "#D1C18E"}}></Col>
        </Row>
        <Slider onChange={this.onChangeSlider.bind(this, 'ValeurTauxSel')} style = {{marginTop:-16}}  min={-1} max={6} defaultValue={-1}  step={0.1}  />
      </div>
    </div>
  )
}

*/
//url(require("./assets/navBar/footer_vague_bleue.svg"))

export default AvaForms;
